// extracted by mini-css-extract-plugin
export default {"container":"whatGPT3_container__YkXep","title":"whatGPT3_title__g4kY3","middle":"whatGPT3_middle__LIIO9","box":"whatGPT3_box__uyfZ1"};